import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/EmissionControlSystemsHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-19.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .ecs { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .ecs-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden; 
  }
  .ecs-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .ecs-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .ecs-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .ecs-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .ecs-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .ecs-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .ecs-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .ecs-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .ecs-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .ecs-bc-item:hover { color: #EB2019; }
  .ecs-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .ecs-bc-sep img { width: 24px; height: 24px; display: block; }
  .ecs-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .ecs-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .ecs-main-section { padding: 80px 0 120px 0; }
  .ecs-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .ecs-article { flex: 1; min-width: 0; }

  .ecs-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .ecs-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .ecs-meta-item:last-child { border-right: none; padding-right: 0; }
  .ecs-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .ecs-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .ecs-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .ecs-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .ecs-article-body p { margin-bottom: 20px; }
  .ecs-article-body p:last-child { margin-bottom: 0; }

  /* Bold section headings */
  .ecs-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 30px 0 15px 0; line-height: 160%; display: block;
  }

  /* Numbered sub-headings */
  .ecs-h3 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 20px 0 10px 0; line-height: 160%; display: block;
  }

  .ecs-article-body strong { font-weight: 600; color: #202020; }

  .ecs-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .ecs-red-link:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .ecs-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .ecs-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .ecs-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .ecs-nav-btn:hover { color: #EB2019; }
  .ecs-nav-btn img { width: 40px; height: 40px; display: block; }

  .ecs-share-icons { display: flex; align-items: center; gap: 20px; }
  .ecs-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .ecs-share-icon:hover { opacity: 0.85; }
  .ecs-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .ecs-sidebar { flex: 0 0 475px; }
  .ecs-sidebar-block { margin-bottom: 60px; }
  .ecs-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .ecs-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .ecs-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .ecs-recent-item:hover .ecs-recent-title { color: #EB2019; }
  .ecs-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .ecs-recent-body { flex: 1; min-width: 0; }
  .ecs-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .ecs-social-icons { display: flex; align-items: center; gap: 30px; }
  .ecs-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .ecs-social-icon:hover { opacity: 0.8; }
  .ecs-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .ecs-hero             { height: 350px; }
    .ecs-hero-content     { padding: 0 32px; }
    .ecs-hero-title       { font-size: 30px; }
    .ecs-hero-divider     { width: 100%; max-width: 479px; }
    .ecs-breadcrumb       { padding: 24px 0 0 0; }
    .ecs-breadcrumb-inner { padding: 0 32px; }
    .ecs-inner            { padding: 0 32px; }
    .ecs-main-section     { padding: 48px 0 60px 0; }
    .ecs-main-row         { flex-direction: column; gap: 48px; }
    .ecs-sidebar          { flex: none; width: 100%; }
    .ecs-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .ecs-hero             { height: 360px; }
    .ecs-hero-content     { padding: 0 16px; }
    .ecs-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .ecs-hero-divider     { width: 100%; }
    .ecs-hero-subtitle    { font-size: 14px; }
    .ecs-breadcrumb       { padding: 30px 0 0 0; }
    .ecs-breadcrumb-inner { padding: 0 16px; }
    .ecs-bc-item          { font-size: 14px; gap: 14px; }
    .ecs-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .ecs-bc-sep img       { width: 22px; height: 22px; }
    .ecs-inner            { padding: 0 16px; }
    .ecs-main-section     { padding: 30px 0 60px 0; }
    .ecs-main-row         { flex-direction: column; gap: 60px; }
    .ecs-sidebar          { flex: none; width: 100%; }
    .ecs-article-title    { font-size: 20px; margin-bottom: 15px; }
    .ecs-article-body     { font-size: 14px; }
    .ecs-article-body p   { margin-bottom: 15px; }
    .ecs-meta-item        { font-size: 14px; }
    .ecs-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .ecs-h2               { font-size: 16px; margin: 30px 0 15px 0; }
    .ecs-h3               { font-size: 16px; margin: 15px 0 10px 0; }
    .ecs-nav-btn img      { width: 24px; height: 24px; }
    .ecs-nav-btn          { font-size: 14px; }
    .ecs-share-icon img   { width: 34px; height: 34px; }
  }
`;

const recentPosts = [
 {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },
];

export default function CompleteGuideEmissionControlSystems() {
  return (
    <div className="ecs">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="ecs-hero">
        <img className="ecs-hero-bg" src={HeroBgImg} alt="Emission Control Systems Hero" />
        <div className="ecs-hero-overlay" />
        <div className="ecs-hero-content">
          <h1 className="ecs-hero-title">
            A Complete Guide to Emission Control Systems: How They Work and Why They Matter
          </h1>
          <hr className="ecs-hero-divider" />
          <p className="ecs-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="ecs-breadcrumb" aria-label="Breadcrumb">
        <div className="ecs-breadcrumb-inner">
          <a href="/" className="ecs-bc-item">Home</a>
          <span className="ecs-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="ecs-bc-item">News &amp; Updates</a>
          <span className="ecs-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="ecs-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="ecs-main-section">
        <div className="ecs-inner">
          <div className="ecs-main-row">

            {/* ── ARTICLE ── */}
            <article className="ecs-article">

              {/* Meta bar */}
              <div className="ecs-meta-bar">
                <span className="ecs-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="ecs-meta-item"><img src={CalendarIcon} alt="date" /> April 28, 2025</span>
                <span className="ecs-meta-item"><img src={ClockIconImg} alt="time" /> 6:50 am</span>
                <span className="ecs-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="ecs-article-title">
                A Complete Guide to Emission Control Systems: How They Work and Why They Matter
              </h1>

              {/* Body */}
              <div className="ecs-article-body">

                <p>Controlling emissions is no longer optional—it's a necessity. With increasing global awareness about climate change and air pollution, emission control systems have become vital parts of industries and transportation. These systems are designed to reduce harmful pollutants released into the atmosphere and play a key role in protecting the environment and human health.</p>

                {/* Article image */}
                <img className="ecs-article-img" src={ArticleImg} alt="Emission Control Systems" />

                <p>This comprehensive guide will explore everything you need about emission control systems, their components, applications, and why optimizing them is crucial for a sustainable future.</p>

                <span className="ecs-h2">What Is an Emission Control System?</span>

                <p>An emission control system is a combination of mechanical and electronic components in vehicles, industrial equipment, and energy systems that reduces the emission of harmful gases like nitrogen oxides (NOx), carbon monoxide (CO), hydrocarbons (HC), and particulate matter (PM).</p>

                <p><strong>Whether integrated into a car's engine or a power plant's exhaust, these systems are designed to:</strong></p>

                <p>• Reduce air pollutants<br />
                • Improve fuel efficiency<br />
                • Comply with environmental regulations</p>

                <span className="ecs-h2">Core Components of an Emission Control System</span>

                <p>An effective emission control system typically includes a variety of technologies, depending on the application:</p>

                <span className="ecs-h3">1. Catalytic Converter</span>
                <p>• Converts CO, NOx, and HC into less harmful gases like nitrogen, water vapor, and carbon dioxide.<br />
                • Widely used in automobiles.</p>

                <span className="ecs-h3">2. Particulate Filters (DPF)</span>
                <p>• Trap and eliminate soot particles from diesel engines.</p>

                <span className="ecs-h3">3. Exhaust Gas Recirculation (EGR)</span>
                <p>• Reduces NOx emissions by recirculating some exhaust gas back into the engine cylinders.</p>

                <span className="ecs-h3">4. Selective Catalytic Reduction (SCR)</span>
                <p>• Common in industrial setups and heavy-duty vehicles.<br />
                • It uses a urea-based solution to convert NOx into nitrogen and water.</p>

                <span className="ecs-h3">5. Electrostatic Precipitators (ESP)</span>
                <p>• Employed in factories and power plants.<br />
                • Electrically charges particles in emissions and collects them on plates.</p>

                <span className="ecs-h2">Types of Transformer Rectifiers</span>

                <p>• Single-phase Rectifier Transformer: Suitable for light-duty applications.<br />
                • Three-phase Rectifier Transformer: Common in industrial setups due to better efficiency and power handling.<br />
                • Oil-cooled vs. Air-cooled Units: Depending on environmental and usage conditions.</p>

                <span className="ecs-h2">Industrial Applications of Emission Control Systems</span>

                <p>Emission control systems are not just limited to automobiles—they are crucial in several high-emission industries:</p>

                <p>• Power Plants: Use ESPs and scrubbers to reduce fly ash and sulfur dioxide.<br />
                • Cement Manufacturing: Integrates bag filters and catalytic reduction.<br />
                • Chemical Processing: Requires scrubbers to neutralize acidic gases.<br />
                • Metallurgy: Uses filters and cyclones to capture particulate matter.</p>

                <span className="ecs-h2">Automotive Emission Control Technologies</span>

                <p>Automobile manufacturers must comply with stringent emission norms such as Euro 6, Bharat Stage VI (India), and EPA regulations in the U.S. To meet these, vehicles integrate:</p>

                <p>• Three-way catalytic converters<br />
                • Advanced fuel injection systems<br />
                • Oxygen sensors for optimal fuel-air ratio</p>

                <p>These innovations ensure cleaner exhaust emissions and better engine performance.</p>

                <span className="ecs-h2">Benefits of Emission Control Systems</span>

                <p>Implementing robust emission control mechanisms provides both environmental and economic advantages:</p>

                <p>• Reduced greenhouse gas emissions<br />
                • Improved public health<br />
                • Increased engine efficiency<br />
                • Compliance with international and local regulations<br />
                • Enhanced brand reputation for companies embracing sustainability</p>

                <span className="ecs-h2">Regulatory Landscape</span>

                <p>Governments and global organizations have established emission standards to combat pollution:</p>

                <p>• The Clean Air Act (USA)<br />
                • Euro Emission Norms (EU)<br />
                • Bharat Stage Emission Standards (India)<br />
                • IMO MARPOL Annex VI (Marine emissions regulation)</p>

                <p>These rules have pushed manufacturers and industries to invest in advanced emission control systems to stay compliant and avoid penalties.</p>

                <span className="ecs-h2">Emerging Technologies in Emission Control</span>

                <p>With growing emphasis on decarbonization and energy efficiency, innovations are shaping the future of emission control:</p>

                <p>• Hybrid emission systems: Combine filters and catalysts for greater efficiency<br />
                • AI-driven sensors: Monitor and optimize emissions in real-time<br />
                • Biofiltration: Uses microbial organisms to break down pollutants<br />
                • Plasma reactors: For low-temperature destruction of volatile organic compounds (VOCs)</p>

                <span className="ecs-h2">Real-World Use Cases</span>

                <span className="ecs-h3">Power Generation</span>
                <p>Thermal power plants in countries like China and India use ESPs and SCRs to control emissions and comply with carbon mandates.</p>

                <span className="ecs-h3">Commercial Vehicles</span>
                <p>European trucks use SCR systems and diesel oxidation catalysts to meet Euro 6 standards.</p>

                <span className="ecs-h3">Urban Infrastructure</span>
                <p>Cities like Tokyo and New York have implemented strict emission control laws for construction and manufacturing sectors.</p>

                <span className="ecs-h2">What Happens Without Emission Control?</span>

                <p>Without proper emission systems in place, the following consequences are inevitable:</p>

                <p>• Increased respiratory diseases<br />
                • Environmental degradation<br />
                • Non-compliance penalties<br />
                • Loss of brand trust<br />
                • Poor fuel economy and engine damage</p>

                <span className="ecs-h2">Best Practices for Businesses</span>

                <p>To make the most of your emission control investments:</p>

                <p>• Conduct regular system audits<br />
                • Stay updated with regional regulations<br />
                • Invest in R&amp;D for future-ready systems<br />
                • Train staff on emission compliance<br />
                • Use real-time monitoring and reporting tools</p>

                <span className="ecs-h2">Final Thoughts</span>

                <p>The need for efficient emission control systems has never been greater. These systems, from heavy industries to daily commutes, play a pivotal role in reducing pollution, meeting regulations, and protecting our planet.</p>

                <p>Understanding how emission control works is essential to making sustainable choices, whether you're a manufacturer, policymaker, or an environmentally conscious consumer.</p>

                <p>Ready to take the next step?</p>

                <p><a href="/contact" className="ecs-red-link">Contact our team</a> for emission system audits</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="ecs-bottom-row">
                <div className="ecs-bottom-nav">
                  <a href="/news/how-medium-frequency-power-switching-transforming-industry" className="ecs-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/transformer-rectifier-applications" className="ecs-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="ecs-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/a-complete-guide-to-emission-control-systems-how-they-work-and-why-they-matter/" className="ecs-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Fa-complete-guide-to-emission-control-systems-how-they-work-and-why-they-matter%2F&mode=login" className="ecs-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Fa-complete-guide-to-emission-control-systems-how-they-work-and-why-they-matter%2F%26title%3DEmission%2520Control%2520System%2520%253A%2520How%2520They%2520Work%2520%2526%2520Why%2520They%2520Matter%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Fa-complete-guide-to-emission-control-systems-how-they-work-and-why-they-matter%2F" className="ecs-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="ecs-sidebar">

              {/* Recent Posts */}
              <div className="ecs-sidebar-block">
                <p className="ecs-sidebar-title">Recent Posts</p>
                <div className="ecs-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="ecs-recent-item">
                      <img src={post.img} alt={post.title} className="ecs-recent-img" />
                      <div className="ecs-recent-body">
                        <span className="ecs-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="ecs-sidebar-block">
                <p className="ecs-sidebar-title">Social Media</p>
                <div className="ecs-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="ecs-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="ecs-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}